export default __webpack_public_path__ + "static/media/document.ff8f47d2.svg";